import {
  CALCULATE_PACKAGE_PRICE_REQUEST,
  CALCULATE_PACKAGE_PRICE_SUCCESS,
  CALCULATE_PACKAGE_PRICE_FAILURE,
} from "../actions/types";

const initialState = {
  price: null,
  loading: false,
  error: null,
};

export default function packagePriceReducer(state = initialState, action) {
  switch (action.type) {
    case CALCULATE_PACKAGE_PRICE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case CALCULATE_PACKAGE_PRICE_SUCCESS:
      return {
        ...state,
        loading: false,
        price: action.payload.price,
      };

    case CALCULATE_PACKAGE_PRICE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
}